/**
 * FormTypeVersionEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { FormTypeEntity } from "../FormTypeEntity";
import { FormTypeViewEntity } from "../FormTypeViewEntity";
import { FormEntity } from "../FormEntity";
import { BugEntity } from "../BugEntity";
import { FormTypeVersionEntity } from "../FormTypeVersionEntity";
declare global {
    interface EntityTypeMap {
        FormTypeVersion: FormTypeVersionEntity;
    }
}
export abstract class FormTypeVersionGeneratedEntity extends BaseEntity {
    public abstract formTypeVersionId: string;
    public abstract templateId: string | null;
    public abstract date: Date;
    public abstract formType: FormTypeEntity;
    public abstract activeForType: FormTypeEntity | null;
    public abstract readonly views: ReadonlyArray<FormTypeViewEntity>;
    public abstract readonly forms: ReadonlyArray<FormEntity>;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
}
